module.exports = __webpack_public_path__ + "static/share.74181a64.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/assets/share.png
// module id = 468
// module chunks = 35783957827783